var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isTooltipInDom
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowed,
              expression: "isShowed",
            },
          ],
          ref: "rootEl",
          staticClass: "base-tooltip",
        },
        [
          _vm.interactive
            ? _c("div", {
                staticClass: "base-tooltip__interactive",
                style: {
                  top: -_vm.interactiveOffset + "px",
                  left: -_vm.interactiveOffset + "px",
                  width: "calc(100% + " + _vm.interactiveOffset * 2 + "px)",
                  height: "calc(100% + " + _vm.interactiveOffset * 2 + "px)",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.forDelegateContent
            ? _c("div", {
                domProps: { innerHTML: _vm._s(_vm.forDelegateContent) },
              })
            : _vm._t("default"),
          _vm._v(" "),
          _vm.arrow
            ? _c("div", { ref: "arrow", staticClass: "base-tooltip__arrow" })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }